import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {TransactionInfoService} from "../../../services/transaction-info.service";
import {ClaimTypes} from "../../../model/claim-type.model";

@Component({
    selector: 'app-trip-cancellation',
    templateUrl: './trip-cancellation.component.html',
    styleUrls: ['./trip-cancellation.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TripCancellationComponent implements OnInit {

    constructor( private transactionInfoService: TransactionInfoService) {
        this.transactionInfoService.getTransactionInfo().setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN]);
    }

  ngOnInit() {
  }

}
